<template>
  <div
    class="sprite-popup setting-popup"
    v-show="boxData.judgeBox"
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
    @click="on$ElClicked()"
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)"
      :style="{'cursor': 'move'}"
    >设置</div>

    <div class="setting-popup__content">
      <!-- text only -->
      <div class="row" v-if="sprite.type === 'Text'" style="height: 48px;justify-content: center;">
        <trigger :sprite="sprite" ref="fontFamilyRow"></trigger>
      </div>
      <div class="row" v-if="sprite.type === 'Text'" style="height: 48px;justify-content: center;">
        <my-input :sprite="sprite" ref="fontSizeRow"></my-input>
      </div>
      <!-- normal options -->
      <div class="row" v-for="(row, i) in rows" :key="i">
        <div class="item" v-for="(item, j) in row" :key="j" @click="openChild(item)">
          <div class="item__icon">
            <i
              v-if="item.name === 'color'"
              class="color-trigger"
              :style="{backgroundColor: colorTrigger}"
            ></i>
            <template v-else>
              <icon
                :url="`../../../static/svg/popups/${item.icon || item.name}.svg`"
                :width="28"
                :height="26"
              ></icon>
              <icon
                :classNames="['active']"
                :url="`../../../static/svg/popups/${item.icon || item.name}-2.svg`"
                :width="28"
                :height="26"
              ></icon>
            </template>
          </div>
          <span>{{(item || {}).text}}</span>
        </div>
      </div>
    </div>

    <div class="setting-popup__close" @click="close">
      <i class="icon-popup-close"></i>
    </div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="onMaskClicked()"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popup from "../mixins/popup";
import myInputRow from "./textSetting/inputRow";
import trigger from "./textSetting/dropdownRow";

export default {
  mixins: [popup],
  components: {
    "my-input": myInputRow,
    trigger
  },
  data() {
    let commonNames = ["basic", "effect", "swap", "shadow", "filter", "flip"];
    return {
      popupType: "spritePopup",
      items: [
        { text: "基础", disabled: false, name: "basic" },
        { text: "颜色", disabled: false, name: "color" },
        { text: "动画", disabled: false, name: "effect" },
        { text: "替换", disabled: false, name: "swap" },
        { text: "阴影", disabled: false, name: "shadow" },
        { text: "滤镜", disabled: false, name: "filter" },
        { text: "翻转", disabled: false, name: "flip" },
        { text: "剪辑", disabled: false, name: "clip" },
        { text: "裁剪", disabled: false, name: "crop" },
        { text: "动作", disabled: false, name: "motion" },

        {
          text: "样式",
          disabled: false,
          name: "textStyle",
          icon: "text-style"
        },
        {
          text: "排版",
          disabled: false,
          name: "textAlign",
          icon: "text-align"
        },
        { text: "艺术字", disabled: false, name: "artText", icon: "art-text" }
      ],
      rows: [],
      commonNames: [...commonNames],
      itemNameMap: {
        Svg: [...commonNames],
        Lottie: [...commonNames, "motion"],
        Image: [...commonNames, "crop"],
        Video: [...commonNames, "clip"],
        Text: ["color", "effect", "textStyle", "textAlign", "shadow", "artText"]
      },
      showChildName: "", // 当前显示的子弹窗的名称
      colorTrigger: "#5778fb",
      reports: {
        basic: "material_setting_panel_base,click_base,设置面板_一级_基础",
        color:
          "material_setting_panel_base,click_fontColor,设置面板_一级_字体颜色",
        effect:
          "material_setting_panel_base,click_animation,设置面板_一级_动画",
        swap: "material_setting_panel_base,click_swap,设置面板_一级_替换",
        filter: "material_setting_panel_base,click_filter,设置面板_一级_滤镜",
        flip: "material_setting_panel_base,click_flip,设置面板_一级_翻转",
        clip: "material_setting_panel_base,click_filmcut,设置面板_一级_剪辑",
        motion:
          "material_setting_panel_base,click_character_action,设置面板_一级_动作",
        crop: "material_setting_panel_base,click_photocut,设置面板_一级_裁剪",
        textStyle:
          "material_setting_panel_base,click_fontStyle,设置面板_一级_字体样式",
        textAlign:
          "material_setting_panel_base,click_font_setType,设置面板_一级_字体排版",
        artText:
          "material_setting_panel_base,click_fontArt,设置面板_一级_字体艺术字",
        shadow: "shadow_setting_panel,click_shadow,阴影设置面板_点击_阴影"
      }
    };
  },
  computed: {
    ...mapGetters(["TOOL", "SelectScenes_Msg", "SelectSprites_Msg"])
  },
  watch: {
    "boxData.judgeBox": {
      handler(val) {
        if (val) {
          let usingItems = this.getUsingItems();
          this.rows = this.getRows(usingItems);

          this.$nextTick(() => {
            this.$refs.fontSizeRow && this.$refs.fontSizeRow.render();

            this.$refs.fontFamilyRow && this.$refs.fontFamilyRow.render();
          });

          if (this.sprite && this.sprite.type === "Text") {
            this.colorTrigger = this.sprite.font.color;
          }
        }

        // tell spriteBtn to hide
        if (!this.sprite) {
          return;
        }
        this.$bus.emit("settingPopup.toggle", val);
      }
    }
  },
  created() {
    this.$bus.on(`colorPickerInput.${this.popupType}`, this.colorPickerInput);
  },
  methods: {
    render() {
      if (this.sprite && this.sprite.type === "Text") {
        this.colorTrigger = this.sprite.font.color;
      }
    },
    getRows(items) {
      let arr = [];
      for (let i = 0; i < items.length; i += 2) {
        let child = [items[i]];
        if (items[i + 1]) {
          child[1] = items[i + 1];
        }
        arr.push(child);
      }
      return arr;
    },
    getUsingItems() {
      if (!this.sprite) {
        return;
      }
      let spriteType = this.sprite.type;
      let names = this.itemNameMap[spriteType] || this.commonNames;
      let filtered = this.items.filter(v => {
        return names.indexOf(v.name) > -1;
      });

      return filtered;
    },

    openChild(item) {
      this.$analysis(this.reports[item.name]);
      let isDo = this.setSprite(item.name, item);
      if (isDo) {
        return;
      }
      let popupName =
        item.name === "motion" ? "motion_Lottie" : `${item.name}Setting`;
      this.$bus.emit("FeaturesPop_vue", {
        name: popupName,
        type: 1,
        isChild: true,
        source: this,
        sprite: this.sprite
      });

      this.showChildName = item.name;
      this.toggleMask(true);
    },

    /**
     * 设置素材：替换，镜像等
     */
    setSprite(itemName, item) {
      let isDo = false;
      switch (itemName) {
        case "swap":
          let longType = this.getNavType();
          let typeArr = longType.split(".");
          // 打开 rightNav
          this.$bus.emit("materialPane_vue", {
            type: typeArr[0],
            name: typeArr[1],
            judge: !!typeArr[1]
          });
          this.$store.commit("save_SpriteOperation", "swap");
          isDo = true;
          break;

        case "flip":
          this.sprite.flipStyle(true);
          isDo = true;
          break;

        case "clip":
          this.$modal.show("videoSprite.cutting", { sprite: this.sprite });
          isDo = true;
          break;

        case "crop":
          // this.$bus.emit('cropImageStart');
          if (this.sprite.cropType !== "svg") {
            this.$bus.emit("cropfreelayer");
          } else {
            this.$bus.emit("cropsvglayer");
          }
          this.$bus.emit("FeaturesPop_vue", {
            name: "cropping",
            type: 1,
            sprite: this.sprite
          });
          this.close();
          isDo = true;
          break;

        case "color":
          this.$bus.emit("FeaturesPop_vue", {
            name: "color",
            // 使用了mixins popup.vue 下两字段就非必传
            // posx : rect.left,
            // posy : rect.top,
            type: 1,
            // color: this.color,
            source: this,
            color: this.sprite.type === "Text" ? this.sprite.font.color : ""
          });
          this.toggleMask(true);
          isDo = true;
          break;

        case "artText":
          if (this.sprite.versionAnyway == "Vertical") {
            this.$message({
              showClose: true,
              message:
                "你好！竖版文字不支持艺术字效果和下划线、倾斜样式，如需使用请调整样式。"
            });
          } else {
            this.$bus.emit("FeaturesPop_vue", {
              name: "artTextSetting",
              type: 1,
              isChild: true,
              source: this,
              sprite: this.sprite
            });
            this.showChildName = item.name;
            this.toggleMask(true);
          }
          isDo = true;
          break;

        default:
          break;
      }

      return isDo;
    },

    onMaskClicked() {
      let name = `${this.showChildName}Setting`;
      this.closeNextPopup(name);
      this.closeNextPopup("color");
      this.closeNextPopup("artTextSetting");
      this.closeNextPopup("motion_Lottie");
    },

    on$ElClicked() {
      this.$refs.fontSizeRow && this.$refs.fontSizeRow.focus(false);
    },

    colorPickerInput(obj) {
      if (this.sprite.type === "Text") {
        this.TOOL.updateSprite(
          this.sprite.id,
          {
            font: {
              color: obj.hex
            }
          },
          this.sprite.scenesId,
          true
        ).then(() => {
          this.render();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 164px;
  // min-height: 280px;
  // max-height: 368px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding-top: 0;
    padding-bottom: 14px;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.row {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 75px;
  width: 140px;
  margin: auto;

  &:after {
    content: " ";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translatex(-50%);
    width: 128px;
    height: 1px;
    background-color: #f0f0f8;
    border-radius: 1px;
  }

  &:last-child {
    &:after {
      content: none;
    }
  }
}

.item {
  width: 70px;
  height: 60px;
  text-align: center;
  cursor: pointer;

  & .icon-component.active {
    display: none;
  }
  &:hover {
    & .icon-component {
      display: none;
    }
    & .icon-component.active {
      display: inline-block;
    }
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin: auto;
  }
}

.color-trigger {
  display: inline-block;
  width: 28px;
  height: 28px;
  background-color: #5778fb;
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/spritePopup.vue